export default class UrlUtils {

    static sanitizePath(path) {
        return path.replace(/^http\:\/\//, '') // remove the leading http:// (temporarily)
                   .replace(/\/+/g, '/')       // replace consecutive slashes with a single slash
                   .replace(/\/+$/, '');
    }
}